import React from 'react'

import Icon, { IconProps } from './Icon'

/**
 * Infoのiマークアイコン
 */
const InfoIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
      >
        <path
          d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm1,15H11V15h2Zm0-4H11V7h2Z"
          transform="translate(-2 -2)"
        />
      </svg>
    </Icon>
  )
}

export default InfoIcon
